import React from 'react';
import PropTypes from 'prop-types';

import { Box, Text, Link } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import styles from './boxTable.module.less';

function PlayButtonDefaultIcon() {
  return (
    <div className={styles.playButtonDefaultIcon}>
      <svg
        viewBox="0 0 16 16"
        aria-hidden="true"
        className="_23CZf0 _2ulGkX"
        fill="currentcolor"
        focusable="false"
      >
        <path
          d={`M12.281 7.202c.313.182.469.45.469.8 0 .352-.156.619-.469.8l-6.875
          4.061c-.3.183-.612.183-.937 0-.313-.169-.469-.436-.469-.8v-8.12c0-.
          391.163-.665.488-.82.339-.17.645-.163.918.019l6.875 4.06z`}
        />
      </svg>
    </div>
  );
}

const BoxTableTile = ({
  smallCopy,
  copy,
  image,
  imageAlt,
  isNarrow,
  linkCopy,
  linkUrl,
  title,
  videoUrl,
  videoCover,
}) => {
  const copyInHTML = (text) => ({ __html: text });
  const [showPlayer, setShowPlayer] = React.useState(false);
  const videoUrlWithAutoPlay = `${videoUrl}&autoplay=1`;

  const handleLoadPlayer = () => {
    setShowPlayer(true);
  };

  const RenderVideo = () => {
    if (videoCover) {
      if (showPlayer) {
        return (
          <iframe
            title="video embed"
            id="player"
            className={styles.videoPlayer}
            type="text/html"
            width="100%"
            height="100%"
            src={videoUrlWithAutoPlay}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        );
      }
      return (
        <React.Fragment>
          <PlayButtonDefaultIcon />
          <Image
            className={styles.videoPlayer}
            objectFit="cover"
            src={videoCover}
            alt="player-cover-image"
            backgroundColor="transparent"
            naturalWidth={564}
            naturalHeight={316}
            lazy
          />
        </React.Fragment>
      );
    }
    return (
      <iframe
        title="video embed"
        id="player"
        className={styles.videoPlayer}
        type="text/html"
        width="100%"
        height="100%"
        src={videoUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  };

  const tileOutput = (
    <div className={styles.boxTableInner}>
      {image && (
        <Image
          src={image}
          alt={imageAlt}
          backgroundColor="transparent"
          naturalWidth={564}
          naturalHeight={316}
          className={styles.boxTableImage}
          lazy
        />
      )}
      <Box className={styles.videoContainer} onClick={handleLoadPlayer}>
        <RenderVideo />
      </Box>
      {title && (
        <div className={styles.boxTableTitle}>
          <Text component="h2" size="large" bold>
            {title}
          </Text>
        </div>
      )}
      {smallCopy && (
        <Text size="small" component="div">
          <div
            className={styles.boxTableSmallCopy}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={copyInHTML(smallCopy)}
          />
        </Text>
      )}
      {copy && (
        <div className={styles.boxTableCopy}>
          <Text>{copy}</Text>
        </div>
      )}
      {linkUrl && (
        <Link className={styles.boxTableLink} href={linkUrl}>
          {linkCopy}
        </Link>
      )}
    </div>
  );

  return isNarrow ? (
    <Box className={styles.boxTableBoxNarrow}>{tileOutput}</Box>
  ) : (
    <Box className={styles.boxTableBox}>{tileOutput}</Box>
  );
};

BoxTableTile.propTypes = {
  smallCopy: PropTypes.string,
  copy: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  isNarrow: PropTypes.bool,
  linkCopy: PropTypes.string,
  linkUrl: PropTypes.string,
  title: PropTypes.string,
  videoUrl: PropTypes.string,
  videoCover: PropTypes.string,
};

BoxTableTile.displayName = 'Box Table Tile';

export default BoxTableTile;
